import { render, staticRenderFns } from "./soloar-sentry-carousel.vue?vue&type=template&id=44074200&scoped=true"
import script from "./soloar-sentry-carousel.vue?vue&type=script&lang=js"
export * from "./soloar-sentry-carousel.vue?vue&type=script&lang=js"
import style0 from "./soloar-sentry-carousel.vue?vue&type=style&index=0&id=44074200&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44074200",
  null
  
)

export default component.exports